import type { KeyboardEvent } from 'react';
import { useContext, useState } from 'react';

import { EditorContext, ModalServiceContext } from './../../../../ricos-context';
import { keyCodes } from './../../../../ricos-shortcuts';

import { OverflownButtonsToolbar } from './data-hooks';

export const useRicosDesktopToolbarActions = () => {
  const editor = useContext(EditorContext);
  const [shouldShowMore, setShouldShowMore] = useState(false);
  const modalService = useContext(ModalServiceContext);

  const onPressEscape = (
    e: KeyboardEvent<HTMLDivElement>,
    moreButton: HTMLButtonElement | null
  ) => {
    if (e.keyCode !== keyCodes.Escape) {
      return;
    }
    setShouldShowMore(false);

    if (!moreButton) {
      editor.adapter.focus();
      return;
    }

    const moreToolbar = document.querySelector(`[data-hook=${OverflownButtonsToolbar}]`);
    if (moreToolbar?.contains(document.activeElement)) {
      moreButton.focus();
      return;
    }

    editor.adapter.focus();
  };

  const onClickOutside = () => {
    // @TODO: After modal service gets refactored, change this
    // This is only here, because MODAL SERVICE CLOSES ONE RENDER AFTER TOOLBARS!
    if (modalService.getOpenModals().length > 0) {
      return;
    }

    if (shouldShowMore) {
      setShouldShowMore(false);
    }
  };

  const toggleMoreItems = () => setShouldShowMore(!shouldShowMore);

  return { onPressEscape, onClickOutside, toggleMoreItems, shouldShowMore };
};
